import React, { useEffect, useState } from 'react';
import '../../../assets/styles/KYC.css';
import {
    DataGrid, GridToolbar, GridToolbarContainer,
    GridToolbarExport,
} from '@material-ui/data-grid';
import { useDistributorContext } from '../../../services/contexts/DistributorContext';
import { configs } from '../../../assets/Config';
import { Link } from 'react-router-dom';
import { useLogin } from '../../../services/contexts/AdminLoginContext';
import LeftBarPage from '../../includes/dashboard/LeftBarPage';
import TopBarPage from '../../includes/dashboard/TopBarPage';
import { useKYCContext } from '../../../services/contexts/KYCContext';
import { useHistory } from 'react-router-dom';


export default function CustomerReviewProLeadPage() {

    const { error, getProLeads, proLeads, setKycRequesterUserDetail, setKycRequesterUserComplete, setpanDoc,
        setaddressDoc,
        setbankDoc,
        setdematDoc } = useKYCContext()

    const { allowedFunc, setCurrModule } = useLogin()

    const [rowsDisplay, setRowsDisplay] = useState(configs.defaultRowPerPage);
    const [page, setPage] = useState(configs.startPage);

    const history = useHistory()

    useEffect(() => {
        (async () => {
            if (allowedFunc.includes(configs.functionList['user_pro:user_pro'])) {
                setCurrModule(configs.modules.custProLead)
                await getProLeads(page, configs.recordPerPage, page === 1 ? true : false)
            } else {
                return history.goBack()
            }
        })()
    }, [page])

    // declare table rows
    const [columns, setColumns] = useState([
        { field: "id", headerName: "ID", minWidth: 100, flex: 0.5, hide: true, filterable: false },
        { field: "name", headerName: "Name", minWidth: 100, flex: 0.4, cellClassName: "break-text" },
        {
            field: "email", headerName: "E-mail", minWidth: 150, flex: 0.4, cellClassName: "break-text f-12", renderCell: (params) => {
                // if (allowedFunc.includes(configs.functionList['distributor_management:load_distributor_details'])) {
                //     return <Link to={`/distributorProfile/${params.row.id}`} onClick={() => {
                //         setKycRequesterUserDetail(params.row)
                //     }}>{params.row.email}</Link>
                // } else {
                return params.row.email
                // }
            }, valueGetter: (value) => value.row.email
        },
        {
            field: "mobile", headerName: "Mobile No.", minWidth: 100, flex: 0.3, cellClassName: "break-text", renderCell: (params) => {
                return params.row.mobile
            }, valueGetter: (value) => value.row.mobile
        },
        { field: "utm", headerName: "utm", minWidth: 100, flex: 0.4, cellClassName: "break-text" },
        { field: "message", headerName: "Message", minWidth: 400, flex: 0.5, cellClassName: "break-text" },
        { field: "timestamp", headerName: "Timestamp", minWidth: 100, flex: 0.5, cellClassName: "break-text" },
    ])

    // react data table export option
    function CustomToolbar() {
        return (
            <GridToolbarContainer>
                <GridToolbarExport csvOptions={{ allColumns: true }}/>
            </GridToolbarContainer>
        );
    }

    // admin kyc requesters basic details ui code
    return (
        <>
            <TopBarPage />
            <div style={{ display: "flex" }}>
                <LeftBarPage />
                <div id='custStatContainer' className="smbo-container">
                    <div style={{ width: "100%" }}>
                        <div className="row mx-md-4 mx-2 my-2 p-0">
                            <div className='col-6 m-0 p-0'>
                                <p className="text-custom-grey h3 mt-2 ml-3">Pro Leads</p>
                            </div>
                            <div className='col-6 text-right'>
                                <button className="btn btn-primary" onClick={(e) => {
                                    e.preventDefault()
                                    getProLeads(0, 0, true)
                                }}>Get All Records</button>
                            </div>
                        </div>
                        <div className="kyc-table">
                            {proLeads ? <DataGrid
                                rows={proLeads}
                                columns={columns}
                                resizable={true}
                                pageSize={rowsDisplay}
                                rowHeight={40}
                                headerHeight={30}
                                pagination
                                components={{
                                    Toolbar: GridToolbar,
                                }}
                                onPageChange={(currenIndex) => {
                                    if ((currenIndex + 1) === Math.ceil(proLeads.length / rowsDisplay)) {
                                        setPage(page + 1);
                                    }
                                }}
                                onPageSizeChange={(rowsBeingDisplayed) => {
                                    setRowsDisplay(rowsBeingDisplayed);
                                }}
                            />
                                : <div className="loader"></div>}
                        </div>


                    </div>
                </div>
            </div>
        </>
    )
}